import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserMakeGroupOwner($userGroupOwnerInput: UserGroupOwnerInput!){
        user_make_group_owner (user_group_owner_data: $userGroupOwnerInput) {
            success
        }
    }
`;

export async function userMakeGroupOwner(userUid: string, groupUid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_make_group_owner: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { userGroupOwnerInput: { 
            user_uid: userUid, 
            group_uid: groupUid 
        } },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_make_group_owner;
}
